module.exports = __webpack_public_path__ + "img/arquitectura 1.2ce53427.png";